import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';
import React from 'react';
import { ExtraListName } from '../../../Dashboard/widgets/orders/OrdersTodayWidget/SmsInboundModal';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import './LinehaulInfoProgressBars.scss';
import { ParcelsLineHaulCount } from '../../../../types/statsTypes';

export function LinehaulInfoProgressBars({
  parcelsLineHaulSummary,
}: {
  parcelsLineHaulSummary: ParcelsLineHaulCount[];
}): JSX.Element {
  return (
    <div className="LinehaulInfoProgressBars">
      <div className="title">{'LINEHAUL'}</div>
      <TableContainer>
        <Table>
          <TableBody>
            {parcelsLineHaulSummary.map(
              (obj: ParcelsLineHaulCount, i: number) => {
                return (
                  <TableRow key={i}>
                    <TableCell>
                      {obj.lineHaulName ? obj.lineHaulName : ExtraListName}{' '}
                    </TableCell>
                    <TableCell>
                      <ProgressBar
                        done={obj.lineHaulParcelsScansDoneForDate}
                        total={obj.lineHaulParcelsScansToDoForDate}
                      />
                    </TableCell>
                  </TableRow>
                );
              }
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
